export default "__VITE_ASSET__COoYC4Ms__"